import {createContext} from "react"

const LocationContext = createContext()
const QueryParamsContext = createContext()

export {LocationContext, QueryParamsContext}
